import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';

const ExternalPage = ({ title, url, blockClasses, frameWidth, frameHeight, background }) => (
  <section className={classnames('block block-external-page', blockClasses, background)}>
    <div className="row columns">
      <div className="block-header">
        <h2>{title}</h2>
      </div>
    </div>
    <div className="row align-center">
      <div className={classnames('columns small-16', frameWidth)}>
        <iframe src={url} height={frameHeight}/>
      </div>
    </div>
  </section>
);

ExternalPage.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  blockClasses: PropTypes.string,
  frameWidth: PropTypes.string,
  frameHeight: PropTypes.string,
  background: PropTypes.string,
};

export default ExternalPage;



// WEBPACK FOOTER //
// ./landing_pages/components/external_page.jsx